export default "__VITE_ASSET__xl7CrTlZ__"